function propertyIsTag(property: string) {
    return property.startsWith('tag_') || property === 'tags';
}

export function extractTaxonomiesFromObject(objet: Record<string, unknown>): Record<string, unknown> {
    return Object.fromEntries(Object.entries(objet).filter(([name]) => propertyIsTag(name)));
}

export function extractTaxonomiesFromObjectAndMapProperty(
    objet: Record<string, unknown>,
    property: string,
    format?: (o: string[]) => string,
) {
    return Object.fromEntries(
        Object.entries(objet)
            .filter(([name]) => propertyIsTag(name))
            .map(([name, concepts]) => {
                const v = Array.isArray(concepts)
                    ? (concepts.map((concept) =>
                          typeof concept === 'object' && concept && property in concept ? concept[property] : concept,
                      ) as string[])
                    : concepts;
                return [name, format && Array.isArray(v) ? format(v) : v];
            }),
    );
}

export function extractTaxonomiesFromObjectAndMapUri(objet: Record<string, unknown>): Record<string, unknown> {
    return extractTaxonomiesFromObjectAndMapProperty(objet, 'uri');
}
